"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var DROPDOWN_HEIGHT = 40;
var DROPDOWN_WIDTH = 206;
var FLAG_SIZE = 24;
var ITEM_SIZE = 36;
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  width: ", "px;\n\n  .CountryDropdown__flag {\n    height: ", "px;\n    width: ", "px;\n    margin-right: ", ";\n  }\n\n  .CountryDropdown__select {\n    position: relative;\n    \n    .InputButton_wrapperContent {\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      line-height: ", ";\n    }\n\n    .CountryDropdown__selected {\n      align-items: center;\n      display: flex;\n    }\n\n    .CountryDropdown__selectedText {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .CountryDropdown__selectedMessage {\n      color: ", ";\n      font-family:  ", ";\n      font-size:  ", ";\n      font-weight:  ", ";\n      line-height:  ", ";\n      line-height: .8rem;\n    }\n\n    .CountryDropdown__selectedCountry {\n      font-size: .875rem;\n      line-height: 1.2;\n    }\n  }\n\n  .CountryDropdown__panel {\n    background-color: ", ";\n    border-radius: 2px;\n    border: 1px solid ", ";\n    bottom: ", "px;\n    box-sizing: border-box;\n    margin-bottom: ", ";\n    max-height: ", "px;\n    min-height: ", "px;\n    overflow: hidden auto;\n    position: absolute;\n    width: ", "px;\n\n    .CountryDropdown__list {\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n    }\n\n    .CountryDropdown__item {\n      background-color: ", ";\n      box-sizing: border-box;\n      height: ", "px;\n      padding: 0 ", ";\n\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    .CountryDropdown__item + .CountryDropdown__item {\n      border-top: 1px solid ", ";\n    }\n\n    .CountryDropdown__link {\n      align-items: center;\n      color: ", ";\n      display: flex;\n      font-size: .875rem;\n      height: ", "px;\n      text-decoration: none;\n    }\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  width: ", "px;\n\n  .CountryDropdown__flag {\n    height: ", "px;\n    width: ", "px;\n    margin-right: ", ";\n  }\n\n  .CountryDropdown__select {\n    position: relative;\n    \n    .InputButton_wrapperContent {\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      line-height: ", ";\n    }\n\n    .CountryDropdown__selected {\n      align-items: center;\n      display: flex;\n    }\n\n    .CountryDropdown__selectedText {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .CountryDropdown__selectedMessage {\n      color: ", ";\n      font-family:  ", ";\n      font-size:  ", ";\n      font-weight:  ", ";\n      line-height:  ", ";\n      line-height: .8rem;\n    }\n\n    .CountryDropdown__selectedCountry {\n      font-size: .875rem;\n      line-height: 1.2;\n    }\n  }\n\n  .CountryDropdown__panel {\n    background-color: ", ";\n    border-radius: 2px;\n    border: 1px solid ", ";\n    bottom: ", "px;\n    box-sizing: border-box;\n    margin-bottom: ", ";\n    max-height: ", "px;\n    min-height: ", "px;\n    overflow: hidden auto;\n    position: absolute;\n    width: ", "px;\n\n    .CountryDropdown__list {\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n    }\n\n    .CountryDropdown__item {\n      background-color: ", ";\n      box-sizing: border-box;\n      height: ", "px;\n      padding: 0 ", ";\n\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    .CountryDropdown__item + .CountryDropdown__item {\n      border-top: 1px solid ", ";\n    }\n\n    .CountryDropdown__link {\n      align-items: center;\n      color: ", ";\n      display: flex;\n      font-size: .875rem;\n      height: ", "px;\n      text-decoration: none;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.fontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.lineHeight;
}, DROPDOWN_WIDTH, FLAG_SIZE, FLAG_SIZE, function (_a) {
    var theme = _a.theme;
    return theme.space.s150;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.smallTextRegular.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.smallTextRegular.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.smallTextRegular.fontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.smallTextRegular.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s600;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.microText.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.microText.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.microText.fontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.microText.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white.s100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s300;
}, DROPDOWN_HEIGHT, function (_a) {
    var theme = _a.theme;
    return theme.space.s100;
}, ITEM_SIZE * 5, ITEM_SIZE, DROPDOWN_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.white.s100;
}, ITEM_SIZE, function (_a) {
    var theme = _a.theme;
    return theme.space.s200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s300;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, ITEM_SIZE);
exports.Wrapper.displayName = 'CountryDropdownWrapper';
var templateObject_1;
